import { io } from "socket.io-client";

// const API = process.env.REACT_APP_API
const api = process.env.REACT_APP_API;
const baseURL = new URL(api);
const socketAPI = baseURL.origin;
let socket;
let retryCount = 0; // Counter to track retry attempts
const MAX_RETRIES = 5; // Maximum number of retries

// Function to get socket instance
export const getSocketInstance = () => {
  if (!socket) {
    const token = localStorage.getItem("accessToken"); // Get token at runtime
    socket = io(socketAPI, {
      transports: ["websocket"],
      auth: { token },
    });

    // Handle connection errors
    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error.message);

      if (
        error.message.includes("not authorized") &&
        retryCount < MAX_RETRIES
      ) {
        retryCount++; // Increment retry counter
        console.log(`Retry attempt ${retryCount}/${MAX_RETRIES}...`);

        socket.disconnect(); // Ensure the current instance is disconnected
        socket = null; // Clear the socket instance

        setTimeout(() => {
          getSocketInstance(); // Retry connecting with a new instance
        }, 1000); // Retry after a delay
      } else if (retryCount >= MAX_RETRIES) {
        console.error(
          "Maximum retry attempts reached. Stopping further retries.",
        );
      }
    });

    // Reset retry count upon successful connection
    socket.on("connect", () => {
      console.log("Socket connected successfully.");
      retryCount = 0; // Reset retry count
    });

    // Centralized message:receive event listener
    socket.on("message:receive", (data) => {
      // console.log("Message received:", data);

      const { channelId, unreadMessageCount, message, createdAt, isBlocked } =
        data;
      const obj = {
        channelId,
        unreadMessageCount,
        message,
        createdAt,
        isBlocked,
      };
      // Broadcast globally for different purposes
      window.dispatchEvent(
        new CustomEvent("socket:message:receive", { detail: obj }),
      );
    });
  }
  return socket;
};

// Function to delete socket instance on logout
export const deleteSocketInstance = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    retryCount = 0; // Reset retry count
  }
};
